import { CustomerTokenType } from 'contexts/CustomerTokenContext';
import { customerIdKey } from 'ducks/client/customers';

const getNutmegKey = (apiKey: string, parameter: string): string => {
  return `nutmeg.${apiKey}.${parameter}`;
};

export const storeCognitoOAuth = (values: CustomerTokenType) => {
  const apiKey = values?.apiKey ?? '';

  if (!apiKey) {
    return;
  }
  localStorage.setItem(getNutmegKey(apiKey, 'idToken'), values.idToken ?? '');
  localStorage.setItem(getNutmegKey(apiKey, 'accessToken'), values.accessToken ?? '');
  localStorage.setItem(getNutmegKey(apiKey, 'refreshToken'), values.refreshToken ?? '');
  localStorage.setItem(getNutmegKey(apiKey, 'expiresAt'), values?.expiresAt?.toString() ?? '');
  localStorage.setItem(getNutmegKey(apiKey, 'idProvider'), values?.idProvider ?? '');
  localStorage.setItem(getNutmegKey(apiKey, 'apiKey'), values?.apiKey ?? '');
};

export const clearCognitoOAuth = (apiKey?: string) => {
  if (apiKey) {
    // Clear nutmeg-prefixed keys
    localStorage.removeItem(getNutmegKey(apiKey, 'idToken'));
    localStorage.removeItem(getNutmegKey(apiKey, 'accessToken'));
    localStorage.removeItem(getNutmegKey(apiKey, 'refreshToken'));
    localStorage.removeItem(getNutmegKey(apiKey, 'expiresAt'));
    localStorage.removeItem(getNutmegKey(apiKey, 'idProvider'));
    localStorage.removeItem(getNutmegKey(apiKey, 'apiKey'));
  }

  // Also clear old keys for backward compatibility
  localStorage.removeItem('idToken');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('expiresAt');
  localStorage.removeItem('idProvider');
  localStorage.removeItem('apiKey');
  localStorage.removeItem(customerIdKey);
};

export const loadCognitoOAuth = (setters: (props: CustomerTokenType) => void, apiKey?: string) => {
  if (!apiKey) {
    return;
  }

  // Try loading nutmeg-prefixed keys first
  const idToken = localStorage.getItem(getNutmegKey(apiKey, 'idToken')) ?? undefined;
  const accessToken = localStorage.getItem(getNutmegKey(apiKey, 'accessToken')) ?? undefined;
  const refreshToken = localStorage.getItem(getNutmegKey(apiKey, 'refreshToken')) ?? undefined;
  const expiresAt = localStorage.getItem(getNutmegKey(apiKey, 'expiresAt')) ?? undefined;
  const idProvider = localStorage.getItem(getNutmegKey(apiKey, 'idProvider')) ?? undefined;
  const storedApiKey = localStorage.getItem(getNutmegKey(apiKey, 'apiKey')) ?? undefined;

  setters({
    idToken,
    accessToken,
    refreshToken,
    expiresAt: expiresAt ? parseInt(expiresAt, 10) : undefined,
    idProvider: idProvider ? (idProvider as any) : undefined,
    apiKey: storedApiKey,
  });
};

export const clearOtherApiKeyData = (currentApiKey: string) => {
  // Get all localStorage keys
  const allKeys = Object.keys(localStorage);

  // Find all nutmeg keys that don't belong to the current API key
  const nutmegKeys = allKeys.filter(
    (key) => key.startsWith('nutmeg.') && !key.startsWith(`nutmeg.${currentApiKey}.`)
  );

  // Remove all nutmeg keys for other API keys
  nutmegKeys.forEach((key) => {
    localStorage.removeItem(key);
  });

  // Clear legacy keys (they don't belong to any specific API key)
  localStorage.removeItem('idToken');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('expiresAt');
  localStorage.removeItem('idProvider');
  localStorage.removeItem('apiKey');
  localStorage.removeItem(customerIdKey);
};

export const printCognitoOAuth = (apiKey?: string) => {
  if (apiKey) {
    console.log('=== Nutmeg-prefixed keys ===');
    console.log('idToken', localStorage.getItem(getNutmegKey(apiKey, 'idToken')));
    console.log('accessToken', localStorage.getItem(getNutmegKey(apiKey, 'accessToken')));
    console.log('refreshToken', localStorage.getItem(getNutmegKey(apiKey, 'refreshToken')));
    console.log('expiresAt', localStorage.getItem(getNutmegKey(apiKey, 'expiresAt')));
    console.log('idProvider', localStorage.getItem(getNutmegKey(apiKey, 'idProvider')));
    console.log('apiKey', localStorage.getItem(getNutmegKey(apiKey, 'apiKey')));
  }
};
